import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import Basis         from '@common/influencer/parts/basis';
import Favorite      from '@common/influencer/parts/favorite';
import Contents      from '@common/influencer/parts/contents';
import Actions       from '@common/influencer/parts/actions';
import MultiAction   from '@common/influencer/parts/multi-action';
// -------------------------------------------------------

class InfluencerCommon extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      data          : {},
      view          : false,
      insta_user_id : null,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 初回データ取得
   */
  UNSAFE_componentWillReceiveProps(nextProps){
    if( nextProps.view == true && this.state.view == false ){
      this.setInstaUserID.bind(this)(this.props.insta_user_id);
    }
  }
  // -------------------------------------------------------
  
  /*
   * データ取得
   */
  setInstaUserID(insta_user_id) {
    this.setState({ insta_user_id: insta_user_id });
    setTimeout( function(){ this.getInfluencerDetail.bind(this)();}.bind(this), 50);
  }
  // -------------------------------------------------------
  
  /*
   * データ取得
   */
  getInfluencerDetail() {
    Utils.request.bind(this)('/api/influencer/detail', { insta_user_id: this.state.insta_user_id },
      function(res){
        this.setState({ data: res.body.data, view: true });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closeEvent() {
    this.setState({ view: false });
    this.props.close_ev.bind(this)(false);
  }
  // -------------------------------------------------------
  
  render() {
    let data   = this.state.data;
    let base   = this.props.base;
    let option = this.props.option;
    if( option == undefined ) option = [];
    
    let columns = [
      <Basis />,
      <Favorite />,
      <Contents />,
      <Actions />,
      <MultiAction />,
    ];
    
    // 登録アクションをしない
    data.is_not_import_action = (option.indexOf('is_not_import_action') >= 0);
    
    // 各種アクションをしない（ゲスト用）
    data.is_guest = (option.indexOf('is_guest') >= 0);
    
    // NEXT/BACKアクション
    let prev = {};
    let next = {};
    if( this.props.list != undefined ){
      try {
        this.props.list.map((d, key) => {
          if( d.insta_user_id != data.insta_user_id ) return;
          
          if( this.props.list[(key - 1)] != undefined ) prev = this.props.list[(key - 1)];
          if( this.props.list[(key + 1)] != undefined ) next = this.props.list[(key + 1)];
        });
      } catch(e) {}
    }
    
    return (
      <div className="influencer-common">
        <ContentsModal
          view      = {this.state.view}
          width     = {'calc(100% - 150px)'}
          height    = {'calc(100% - 150px)'}
          max_width = {800}
          close_ev  = {this.closeEvent.bind(this)}
          html      = {
            <div className="modal-item">
              { columns.map((html, key) => {
                return React.cloneElement(html, { key: key, data: data, tab_mode: this.props.tab_mode, refresh_ev: this.getInfluencerDetail.bind(this), list_update_ev: this.props.list_update_ev.bind(this), base: base });
              })}
              
              <NextPrevButton type="prev" data={prev} action_ev={this.setInstaUserID.bind(this)} />
              <NextPrevButton type="next" data={next} action_ev={this.setInstaUserID.bind(this)} />
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class NextPrevButton extends React.Component {
  render() {
    let data = this.props.data;
    if( Object.keys(data).length == 0 ) return null;
    
    return (
      <div className={'next-prev-button '+ this.props.type}>
        <div className="button-action" onClick={this.props.action_ev.bind(this, data.insta_user_id)}>
          <i className="material-icons">{(this.props.type == 'next') ? 'arrow_forward_ios' : 'arrow_back_ios'}</i>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerCommon;